// extracted by mini-css-extract-plugin
export default {"wrap":"xJ-z","subtitle":"yJ-z","contentWrap":"zJ-z","imgWrap":"AJ-z","heading":"BJ-z","copy":"CJ-z"};